// removed by extract-text-webpack-plugin
module.exports = {"component":"_6kjGsqsKDVFE1imsJ2SIq","header":"_2FfbgHGDKVRAPrmG97-jM-","list":"_1cTAaxkBA_-qhVTt1CTe0e","attachment":"fMA2nuWGLlpufPmNk7Lb_","image":"_3MbWQ8g55DuhYruuf8WBlk","link":"_36WH7oUP4Li8HjmxvbAy4F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/Attachments/Attachments.css
// module id = 1343
// module chunks = 0